import { Injectable } from '@angular/core';
import { InitialiseScanner } from '@monorepo/core-data';
import { TAppMaster } from '@monorepo/resolvers';
import { TMasterdataSyncStatus } from '@monorepo/types';
import { Store, select } from '@ngrx/store';
import {
  ClearSyncingStatus,
  FetchHealthCheckStatusAndUpdate,
  InitSyncingStatus,
  UpdateBulkSyncingStatus,
  UpdateOnlineStatus,
  UpdateSyncingStatus,
} from './metadata.actions';
import {
  getEventsBatchCount,
  getEventsBatchCountAndOnlineStatus,
  getMasterdataListStatuses,
  getOnlineStatus,
  isScannerInitialised,
} from './metadata.query';

@Injectable({
  providedIn: 'root',
})
export class InputAppMetadataDBFacade {
  constructor(private store: Store<TAppMaster>) {}

  init() {
    // PBI-2882 Removing healthcheck logic to NetworkChangeReceiver. Removing healthcheck code completely pending
    // this.fetchAndUpdateHealthCheckStatus();
    // setInterval(() => {
    //   this.fetchAndUpdateHealthCheckStatus();
    // }, HEALTH_CHECK_TIME_DIFFERENCE_IN_MILLI_SECONDS);
  }

  getHealthCheckStatus() {
    return this.store.pipe(select(getOnlineStatus));
  }

  getOnlineStatus() {
    return this.store.pipe(select(getOnlineStatus));
  }

  getEventsBatchCount() {
    return this.store.pipe(select(getEventsBatchCount));
  }

  getEventsBatchCountAndOnlineStatus() {
    return this.store.pipe(select(getEventsBatchCountAndOnlineStatus));
  }

  fetchAndUpdateHealthCheckStatus() {
    this.store.dispatch(new FetchHealthCheckStatusAndUpdate());
  }

  initSyncingStatuses(keys: string[]) {
    return this.store.dispatch(new InitSyncingStatus(keys));
  }

  clearSyncingStatuses() {
    return this.store.dispatch(new ClearSyncingStatus());
  }

  updateSyncingStatus(key: string, status: TMasterdataSyncStatus) {
    return this.store.dispatch(new UpdateSyncingStatus(key, status));
  }

  updateBulkSyncingStatus(keys: string[], status: TMasterdataSyncStatus) {
    return this.store.dispatch(new UpdateBulkSyncingStatus(keys, status));
  }

  getMasterdataListStatuses() {
    return this.store.pipe(select(getMasterdataListStatuses));
  }

  isScannerInitialised() {
    return this.store.pipe(select(isScannerInitialised));
  }

  scannerInitialised(isInitialised: boolean) {
    return this.store.dispatch(new InitialiseScanner(isInitialised));
  }

  updateOnlineStatusFromDevice(status: boolean) {
    return this.store.dispatch(new UpdateOnlineStatus(status));
  }
}
